export default __webpack_public_path__ + "static/media/noexpl_15_EN.64d2cea7.png";